// src/pages/StudentAnswersPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Table from "../shared/table/Table";

const StudentAnswersPage = () => {
  const { id } = useParams(); // student_id
  const [results, setResults] = useState([]);
  const [student, setStudent] = useState(null);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/form-reader-results/by-student/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      // response.data = { results: [ {...}, {...}, ... ], student: { ... } }
      setResults(response.data.results || []);
      setStudent(response.data.student || null);
    } catch (error) {
      console.error("❌ Veriler alınamadı:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Result ID"
      },
      {
        accessorKey: "optical_form_id",
        header: "Form ID"
      },
      {
        accessorKey: "opticalFormName",
        header: "Optik Form"
      },
      {
        accessorKey: "institutionName",
        header: "Kurum"
      },
      {
        accessorKey: "classNameInfo",
        header: "Sınıf"
      },
      {
        accessorKey: "raw_answers",
        header: "Cevaplar",
        cell: (info) =>
          Array.isArray(info.getValue()) ? info.getValue().join(", ") : ""
      },
      {
          accessorKey: "correct",
          header: "Doğru",
          cell: (info) => info.getValue() !== undefined ? info.getValue() : "N/A"
      },
      {
        accessorKey: "wrong",
        header: "Yanlış"
      },
      {
        accessorKey: "blank",
        header: "Boş"
      },
      {
        accessorKey: "score",
        header: "Puan"
      },
      {
        accessorKey: "created_at",
        header: "Tarih",
        cell: (info) =>
          new Date(info.getValue()).toLocaleDateString("tr-TR")
      },
      // ► RAPOR İNDİR butonu sütunu
      {
        id: "download_report",
        header: "Rapor",
        cell: ({ row }) => {
          const result = row.original;
          return (
            <button
              className="btn btn-sm btn-primary"
              onClick={() => downloadSkillReport(result.id)}
            >
              PDF İndir
            </button>
          );
        }
      }
    ],
    []
  );

  // ► Yeni fonksiyon: /api/skills/report/:resultId endpoint’ine istek atıp PDF indirir
  const downloadSkillReport = async (resultId) => {
    try {
      const token = localStorage.getItem("admin_token");
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/processing/skills/report/${resultId}`,
        {
          responseType: "blob", // Önemli: PDF olduğu için blob
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      // PDF blob’una dosya adı vermek için:
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      // Dosya ismini istediğiniz gibi ayarlayabilirsiniz:
      link.setAttribute("download", `skill_report_${resultId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ Rapor indirilemedi:", error);
    }
  };

  if (!results.length && student === null) {
    return <p>Yükleniyor...</p>;
  }

 return (
    <div className="container py-3">
      <h3 className="mb-4">
        {student.first_name} {student.last_name} – {student.school_no} Cevapları
      </h3>

      {/* 1) Tablo */}
      <Table data={results} columns={columns} />

      {/* 2) Optik formlar galerisi – TABLOYU TAKİBEN */}
      {Array.isArray(student.optical_forms) && student.optical_forms.length > 0 && (
        <div className="mt-4">
          {student.optical_forms.map((fp) => {
            // fp örn: "cdn/form_reader/fr_123456789.png"
            // API_BASE_URL = "http://localhost:5000/api" diye ayarlıysa base'i şöyle kırpın:
            const base = process.env.REACT_APP_API_BASE_URL.replace("/api", "");
            const url = `${base}/${fp}`;
            return (
              <img
                key={fp}
                src={url}
                alt="Optik Form"
                style={{
                  width: "100%",        // CONTAINER genişliğini kapla
                  maxWidth: 600,        // istersen max genişlik sınırı
                  height: "auto",
                  display: "block",
                  margin: "1rem auto",  // ortala
                }}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StudentAnswersPage;
